import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IManufacture } from 'src/app/shared/services/dealer.service';
import { OrdersService, PendingDataForMonth } from 'src/app/shared/services/orders.service';
import { IState } from 'src/app/shared/store/root.reducer';

declare var $: any;

@Component({
  selector: 'app-pending-carousel',
  templateUrl: './pending-carousel.component.html',
  styleUrls: ['./pending-carousel.component.scss']
})
export class PendingCarouselComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  manufactures: IManufacture[] = [];
  pendingData: IPendingData[] = [];
  activeIndex = 0;

  constructor(
    private orderService: OrdersService,
    private store: Store<IState>) { }

  ngOnInit() {
    this.loadStore();
    $('.carousel').carousel({
      interval: 4000
    });
    $(document).on('click', '#playPauseBtn', function () {
      const $el = $(this);
      const isPlaying = $el.hasClass('is-paused');
      const isPaused = $el.hasClass('is-playing');
      if (isPaused) {
        // play it
        $('#claimCarousel').carousel('cycle');
        $el.removeClass('is-playing');
        $el.addClass('is-paused');
      } else if (isPlaying) {
        // pause it
        $('#claimCarousel').carousel('pause');
        $el.removeClass('is-paused');
        $el.addClass('is-playing');
      }
    });
    $('.active').not(':last').remove();
  }

  private loadStore() {
    this.subscriptions.push(this.store.pipe(select(state => state.appParams.manufacturers)).subscribe(manufacturers => {
      if (manufacturers && manufacturers.length > 0) {
        this.manufactures = manufacturers;
        const params = {
          value: manufacturers.map(d => d.manId).toString(),
          encrypted: true
        };
        let index = 0;
        this.orderService.getPendingDataForMonth(params).subscribe(pendingResult => {
          this.pendingData = [];
          this.manufactures.map(manufacture => {
            const pending = pendingResult[index];
            this.pendingData.push({
              id: manufacture.manId,
              name: manufacture.manufacture,
              data: pending,
            });
            index++;
          });
          $('#claimCarousel').carousel('cycle');
        });
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }

  preview() {
    if (this.activeIndex - 1 > this.pendingData.length) {
      this.activeIndex -= 1;
    } else {
      this.activeIndex = this.pendingData.length - 1;
    }
  }

  next() {
    if (this.activeIndex + 1 < this.pendingData.length) {
      this.activeIndex += 1;
    } else {
      this.activeIndex = 0;
    }
  }
}

interface IPendingData {
  id: number;
  name: string;
  data: PendingDataForMonth;
}
